import { useState } from 'react';
import type { LeadStatus } from '@entities/crm';

export interface DragContext {
  draggingId: string | null;
  hoverColumn: LeadStatus | null;
}

export function useDragState() {
  const [ctx, setCtx] = useState<DragContext>({ draggingId: null, hoverColumn: null });
  return {
    ctx,
    onDragStart: (id: string) => setCtx({ draggingId: id, hoverColumn: null }),
    onDragOverColumn: (column: LeadStatus) =>
      setCtx((prev) => (prev.hoverColumn === column ? prev : { ...prev, hoverColumn: column })),
    onDragEnd: () => setCtx({ draggingId: null, hoverColumn: null }),
  };
}
